import { getJson, postJson, postOk } from "../commonQueries";
import { UserNotification } from "./models/UserNotification";

export type NotificationsCount = { count: number };

export async function getNotificationsCount(): Promise<NotificationsCount> {
    return await getJson(`/api/notifications/count`);
}


export type NotificationsQuery = {
    page: number
}

export async function listUserNotifications(q: NotificationsQuery): Promise<UserNotification[]> {    
    return await getJson(`/api/notifications?page=${q.page}`)
}

export async function confirmAllNotifications(): Promise<void> {
    return await postOk('/api/notifications/confirm-all')
}

export async function confirmNotification(uuid: string): Promise<void> {
    return await postOk(`/api/notifications/${uuid}/confirm`);
}
